import './mapInfo.css';

const MapInfoTable = ({ item, dataSource, setDataSource, chngState }) => {
  let top = '0' + '%';
  let left = '0' + '%';
  //광덕면
  if (item.dongCode === '4413132000') {
    top = '80' + '%';
    left = '10' + '%';
  }
  //동면
  else if (item.dongCode === '4413137000') {
    top = '53' + '%';
    left = '55' + '%';
  }
  //목천읍
  else if (item.dongCode === '4413125000') {
    top = '66' + '%';
    left = '27' + '%';
  }
  //문성동
  else if (item.dongCode === '4413152000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //백석동
  else if (item.dongCode === '4413356000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //병천면
  else if (item.dongCode === '4413136000') {
    top = '38' + '%';
    left = '50' + '%';
  }
  //봉명동
  else if (item.dongCode === '4413155000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //부성1동
  else if (item.dongCode === '4413358000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //부성2동
  else if (item.dongCode === '4413359000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //북면
  else if (item.dongCode === '4413133000') {
    top = '27' + '%';
    left = '44' + '%';
  }
  //불당동
  else if (item.dongCode === '4413356500') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //성거읍
  else if (item.dongCode === '4413325300') {
    top = '25' + '%';
    left = '33' + '%';
  }
  //성남면
  else if (item.dongCode === '4413134000') {
    top = '74' + '%';
    left = '33' + '%';
  }
  //성정1동
  else if (item.dongCode === '4413351000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //성정2동
  else if (item.dongCode === '4413352000') {
    top = '50' + '%';
    left = '13' + '%';
  }
  //성환읍
  else if (item.dongCode === '4413325000') {
    top = '10' + '%';
    left = '23' + '%';
  }
  //수신면
  else if (item.dongCode === '4413135000') {
    top = '65' + '%';
    left = '45' + '%';
  }
  //신방동
  else if (item.dongCode === '4413157000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //신안동
  else if (item.dongCode === '4413159000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //쌍용1동
  else if (item.dongCode === '4413353000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //쌍용2동
  else if (item.dongCode === '4413354000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //쌍용3동
  else if (item.dongCode === '4413355000') {
    top = '50' + '%';
    left = '13' + '%';
  }
  //원성1동
  else if (item.dongCode === '4413153000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //원성2동
  else if (item.dongCode === '4413154000') {
    top = '50' + '%';
    left = '13' + '%';
  }
  //일봉동
  else if (item.dongCode === '4413156000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //입장면
  else if (item.dongCode === '4413331000') {
    top = '13' + '%';
    left = '38' + '%';
  }
  //중앙동
  else if (item.dongCode === '4413151000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //직산읍
  else if (item.dongCode === '4413325600') {
    top = '23' + '%';
    left = '13' + '%';
  }
  //청룡동
  else if (item.dongCode === '4413158000') {
    top = '40' + '%';
    left = '13' + '%';
  }
  //풍세면
  else if (item.dongCode === '4413131000') {
    top = '64' + '%';
    left = '13' + '%';
  }
  //아무것도 아닐시
  else {
  }

  let tableOpacity = 0;
  let tableDisplay = '';
  let tableZIndex = 100;

  // if (item.isOver === undefined) {
  //   tableDisplay = 'none';
  // } else {
  //   //만약 지도를 클릭하면 그 지도에 해당하는 테이블만 보여줌
  //   if (item.isClicked === true) tableOpacity = 1;
  //   //지도 클릭시 다른 테이블들은 false가 됨
  //   else if (item.isClicked === false) {
  //     //지도 클릭 후 다른 테이블 오버 시 오버한 것만 보여줘야 함
  //     if (item.isOver === 0) tableDisplay = 'none';
  //     else if (item.isOver === 1) tableOpacity = 1;
  //     if (item.isOver === 2) tableDisplay = 'none';
  //   }
  //   //지도를 클릭하지 않았다면(0) 남은 테이블들을 보여줘야함
  //   else if (item.isClicked === 0) {
  //     //지도에 마우스 오버 안했을 때에는 다른 테이블들을 보여줘야 함
  //     if (item.isOver === 0) tableOpacity = 0.5;
  //     //지도에 마우스 오버 시에는 해당 테이블만 보여주고(1) 다른 테이블들은(2) 안보여줌
  //     else if (item.isOver === 1) tableOpacity = 1;
  //     else if (item.isOver === 2) tableDisplay = 'none';
  //   }
  // }

  if (item.isClicked === true) tableOpacity = 1;
  //지도 클릭시 다른 테이블들은 false가 됨
  else {
    //지도 클릭 후 다른 테이블 오버 시 오버한 것만 보여줘야 함
    if (item.isOver) {
      tableOpacity = 1;
      tableZIndex = 9999;
    } else tableDisplay = 'none';
  }

  // tableOpacity = 1;
  // tableDisplay = 'auto';
  return (
    <div
      className="MapInfoTable"
      id={`dong_${item.dongCode}`}
      style={{ top: top, left: left, opacity: tableOpacity, display: tableDisplay, zIndex: tableZIndex }}>
      <table>
        { chngState ?
          <>
            <thead>
              <th colSpan="4" style={{ backgroundColor: item.isClicked ? 'orange' : '' }}>
                {item.dongTerm}({item.normalCnt + item.warnCnt + item.dangerCnt + item.offCnt + item.planCnt})
              </th>
            </thead>
            <tbody>
            <colgroup>
            </colgroup>
              <tr>
                <td width="33%">
                  <span>정상</span>
                  <span>{item.normalCnt}</span>
                </td>
                <td colspan="2" width="34%">
                  <span>경고</span>
                  <span>{item.warnCnt}</span>
                </td>
                <td width="33%">
                  <span>위험</span>
                  <span>{item.dangerCnt}</span>
                </td>
              </tr>
              <tr>
                <td colspan="2" width="50%" style={{ borderBottomLeftRadius: '3px' }}>
                  <span>미작동</span>
                  <span>{item.offCnt}</span>
                </td>
                <td colspan="2" width="50%" style={{ borderBottomRightRadius: '3px' }}>
                  <span>설치예정</span>
                  <span>{item.planCnt}</span>
                </td>
              </tr>
            </tbody>
          </>
          :
          <>
            <thead>
              <th colSpan="2" style={{ backgroundColor: item.isClicked ? 'orange' : '' }}>
                {item.dongTerm}({item.activeCnt + item.eatCnt + item.sleepCnt + item.outCnt})
              </th>
            </thead>
            <tbody>
              <tr>
                <td width="50%">
                  <span>활동</span>
                  <span>{item.activeCnt}</span>
                </td>
                <td width="50%">
                  <span>식사</span>
                  <span>{item.eatCnt}</span>
                </td>
              </tr>
              <tr>
                <td width="50%" style={{ borderBottomLeftRadius: '3px' }}>
                  <span>수면</span>
                  <span>{item.sleepCnt}</span>
                </td>
                <td width="50%" style={{ borderBottomRightRadius: '3px' }}>
                  <span>자리비움</span>
                  <span>{item.outCnt}</span>
                </td>
              </tr>
            </tbody>
          </>
        }
      </table>
    </div>
  );
};

export default MapInfoTable;
